export enum ChecklistDisplay {
    Numbered = "numbered",
    Status = "status",
}
